<template>
  <div class="content doctorInformation">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">所属企业</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.tenantGuid" filterable placeholder="请选择"
            clearable @change="companyChange">
            <el-option v-for="item in companyList" :key="item.sendTenantGuid" :label="item.sendTenantName"
              :value="item.sendTenantGuid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">联系人类型</div>
          <el-select size="mini" class="ipt-sty" ref="mySelected" style="width:100%;"
            v-model="searchData.clientType"  @change="typeChange" filterable  placeholder="请输入关键词">
            <el-option v-for="item in clientTypeList" :key="item.value" :label="item.text"
              :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" v-if="searchData.clientType==10">
          <div class="search-area-div">商业公司</div>
          <el-select size="mini" class="ipt-sty" ref="mySelected" style="width:100%;"
            v-model="searchData.franchiseeName" @focus="selectFocus" v-loading="franchiseeSelectLoading"
            :remote-method="getFranchisee" filterable remote placeholder="请输入关键词" clearable>
            <el-option v-for="item in franchiseeSelectList" :key="item.guid" :label="item.franchiseeName"
              :value="item.franchiseeName">
            </el-option>
          </el-select>
          <!-- <el-input v-model.trim="searchData.franchiseeName" placeholder="请输入" clearable></el-input> -->
        </el-col>
        <el-col :span="6" v-if="searchData.clientType==15">
          <div class="search-area-div">药店</div>
          <el-select size="mini" class="ipt-sty" ref="mySelected" style="width:100%;"
            v-model="searchData.franchiseeName" @focus="selectFocus" v-loading="franchiseeSelectLoading"
            :remote-method="getCustomer" filterable remote placeholder="请输入关键词" clearable>
            <el-option v-for="item in customerList" :key="item.guid" :label="item.customerName"
              :value="item.customerName">
            </el-option>
          </el-select>
          <!-- <el-input v-model.trim="searchData.franchiseeName" placeholder="请输入" clearable></el-input> -->
        </el-col>
        
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="text" @click="showMore = !showMore" :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'">
            {{ showMore ? '收起筛选' : '更多筛选' }}
          </el-button>
          <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="24" class="mt15" v-if="showMore">
        <el-col :span="6">
          <div class="search-area-div">联系人姓名</div>
          <el-input size="mini" class="ipt-sty" v-model.trim="searchData.clientName" placeholder="请输入"
            clearable></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">业务指派人</div>
          <el-input  class="ipt-sty" size="mini" v-model.trim="searchData.createUserName" placeholder="请输入业务指派人" clearable></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">指派人手机</div>
          <el-input  class="ipt-sty" size="mini"  v-model.trim="searchData.createUserMobile" placeholder="请输入指派人手机"
            clearable></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">启用状态</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.bizStateList" placeholder="请选择" multiple filterable>
            <el-option v-for="item in bizStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <!-- <el-row :gutter="24" class="mt15" v-show="showMore">
        <el-col :span="6">
          <div class="search-area-div">更新时间</div>
          <el-date-picker
            size="mini"
            v-model="updateTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">更新人</div>
          <el-input
            size="mini"
            v-model="searchData.updateName"
            class="ipt-sty"
            placeholder="请输入数据更新人姓名"
            clearable
          ></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核状态</div>
          <el-select size="mini" class="ipt-sty" v-model="searchData.approveState" placeholder="请选择" filterable>
            <el-option v-for="item in approveStateOp" :key="item.value" :label="item.text" :value="item.value">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">审核时间</div>
          <el-date-picker
            size="mini"
            v-model="approveTime"
            type="daterange"
            class="ipt-sty"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-col> 
        
        </el-row> -->
    </div>
    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area p16">
        <el-button v-if="getBtnPermissionsByName('添加资料')" icon="el-icon-plus" size="mini" type="info" @click="addContent">添加资料</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导入')" size="mini" type="info" @click="batchImport">批量导入</el-button>
        <el-button v-if="getBtnPermissionsByName('批量导出')" size="mini" type="info" @click="report"
          v-loading.fullscreen.lock="fullscreenLoading">批量导出</el-button>
        <el-button v-if="getBtnPermissionsByName('批量启用')" size="mini" @click="batchChangeState('Y')">批量启用</el-button>
        <el-button v-if="getBtnPermissionsByName('批量停用')" size="mini" @click="batchChangeState('S')">批量停用</el-button>  
        <el-button v-if="getBtnPermissionsByName('批量删除')" size="mini" @click="getDeleteData(1, '')">批量删除</el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData" :height="tableHeight" stripe border style="width: 100%" v-loading="tableLoading" row-key="guid"
        @selection-change="handleSelectionChange" >
        <el-table-column type="selection" width="40" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (searchData.pageIndex - 1) * searchData.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="240" prop="tenantName" label="所属企业" header-align="center"
          align="left"></el-table-column>
        <el-table-column show-overflow-tooltip min-width="120" prop="clientType" label="联系人类型" header-align="center"
          align="left">
          <template slot-scope="scope">
            {{ scope.row.clientType==10?'商业公司联系人':'药店联系人' }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip min-width="240" prop="franchiseeName" :label="clientType==10?'商业公司':'药店'" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.franchiseeName || '-' }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="clientName" width="96" label="姓名" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.clientName || '-' }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="mobileNo" width="120" label="联系方式" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
        </el-table-column>
        <el-table-column prop="sex" width="80" label="性别" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.sex == 'M' ? '男' : scope.row.sex == 'F' ? '女' : '-' }}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="position" label="岗位" header-align="center" width="140"
          align="left">
          <template slot-scope="scope">{{ scope.row.position || '-' }}</template>
        </el-table-column>
        <!-- <el-table-column
          prop="updateName"
          label="更新人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="70"
        >
          <template slot-scope="scope">{{ scope.row.updateName || '-' }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column width="160" prop="approveTime" label="审核时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.approveTime | getTimeDate }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          prop="approveState"
          width="96"
          label="审核状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.approveState" :type="type[scope.row.approveState]">{{
              approveStateObj[scope.row.approveState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column> -->
        <el-table-column
          prop="bizState"
          width="96"
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.bizState" :type="type[scope.row.bizState]">{{
              bizStateObj[scope.row.bizState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="contacts" label="指派人手机号" width="130" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserMobile || '-' }}</template>
        </el-table-column>
        <el-table-column prop="contactTel" show-overflow-tooltip width="120" label="业务指派人" header-align="center"
          align="left">
          <template slot-scope="scope">{{ scope.row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <a v-if="getBtnPermissionsByName('编辑')" class="txt-color" @click="addContent(scope.row,false)">编辑 | </a>
            <!-- <a v-if="scope.row.approveState === 'A' " class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a> -->
            <!-- <a v-if="getBtnPermissionsByName('审核')"  class="txt-color" @click="toReview(scope.row)">
                审核 |
            </a>
            <a v-if="scope.row.approveState === 'R' ||scope.row.approveState === 'Y'" class="txt-color" @click="toReview(scope.row)">
              撤回重审 |
            </a> -->
            <a v-if="getBtnPermissionsByName('删除')" class="txt-color" @click="getDeleteData(2, scope.row.guid)">删除｜</a>
            <a v-if="getBtnPermissionsByName('详情')" class="txt-color" @click="addContent(scope.row,true)">详情 </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange"
      @current-change="handleCurrentChange"  :page-sizes="[10,20,50,100,200]" :current-page="searchData.pageIndex"
      :page-size="searchData.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="searchData.totalRows">
    </el-pagination>
  </div>
</template>

<script>
import btnPermisson from '../mixins/btnPermisson';
export default {
  mixins:[btnPermisson],
  data() {
    return {
      showMore: false, // 筛选项显示更多，默认否，最多显示三个
      tableHeight: window.innerHeight - 274,
      contentMainHeight:window.innerHeight - 200,
      fullscreenLoading: false,
      timeRange: '',
      updateTime: [], // 更新时间
      approveTime: [], // 审核时间
      clientType:'10',//获取列表后改变，用于列表商业公司/药店
      searchData: {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        clientName: '',
        clientType: '10',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        franchiseeName: '',
        createUserName: '',
        createUserMobile: '',
        sendTenantGuid: localStorage.guid,
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      },
      tableLoading: false,
      franchiseeSelectLoading: false,
      right: 'right',
      tableData: [],
      technicalTitlesList: [],
      multipleSelection: [],
      franchiseeSelectList: [],
      customerList:[],
      companyList: [],
      approveStateOp: [
        {
          text: '待审核',
          value: 'A',
        },
        {
          text: '已通过',
          value: 'Y',
        },
        {
          text: '已驳回',
          value: 'R',
        },
      ],
      bizStateOp: [
        
        {
          value: "S",
          text: "停用",
        },
        {
          value: "Y",
          text: "启用",
        },
      ],
      clientTypeList: [
        
        {
          value: "10",
          text: "商业公司联系人",
        },
        {
          value: "15",
          text: "药店联系人",
        },
      ],
      bizStateObj: {
        S: '停用',
        Y: '启用',
      },
      type: {
        A: 'warning',
        Y: 'success',
        R: 'danger',
        N: 'info',
        S: 'danger',
      },
      approveStateObj: {
        A: '待审核',
        Y: '已通过',
        R: '已驳回',
        N: '初始',
      },
    };
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 323;
        this.contentMainHeight = window.innerHeight - 250;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 274;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  activated() {
    if (!sessionStorage.businessBack) {
      this.searchData = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        clientName: '',
        clientType: '10',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        franchiseeName: '',
        createUserName: '',
        createUserMobile: '',
        sendTenantGuid: localStorage.guid,
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      }
      if (this.$route.query.tenantGuid) {
        this.searchData.tenantGuid = this.$route.query.tenantGuid;
      }
      if (this.$route.query.franchiseeName) {
        this.searchData.franchiseeName = this.$route.query.franchiseeName;
      }
      if (this.$route.query.clientType) {
        this.searchData.clientType = this.$route.query.clientType;
        this.clientType = this.$route.query.clientType;
      }
      this.getList();
      this.getFranchisee()
      this.getCustomer()
      this.getFormConfig();
      this.getCompany();
    }
  },
  created() {
    // if(sessionStorage.businessPageIndex&&sessionStorage.businessBack){
    //   this.searchData.pageIndex = Number(sessionStorage.businessPageIndex);
    // }
    if (this.$route.query.tenantGuid) {
      this.searchData.tenantGuid = this.$route.query.tenantGuid;
    }
    if (this.$route.query.franchiseeName) {
      this.searchData.franchiseeName = this.$route.query.franchiseeName;
    }
    if (this.$route.query.clientType) {
      this.searchData.clientType = this.$route.query.clientType;
      this.clientType = this.$route.query.clientType;
      this.getList();
    }
    // this.getList();
    this.getFranchisee()
    this.getCustomer()
    this.getFormConfig();
    this.getCompany();
    //按钮权限
    this.getMenuList();
  },
  activated() {
    this.getList();
  },
  methods: {
    
    getFormConfig() {
      this.api.get(
        `/${serverConfig.msConfigureService}/function/func/get-by-code?functionCode=TXL`
      ).then((resp) => {
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let data = resp.data.data;
          if (data && data.fieldList) {
            data.fieldList.filter(i => {
              return (i.appSideType == '0' || i.appSideType == '1') && i.showPosition.indexOf('1') > -1;
            })
            localStorage.setItem('TXL_CONFIG', JSON.stringify(data))
          }
          if (!resp.data.data) {
            localStorage.removeItem('TXL_CONFIG')
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },  
    batchImport(guid) {
      let type=this.searchData.clientType==10? '0023':'0031'
      this.$router.push({ path: '/importNewManagementList',query:{ productGuid:this.$route.query.productGuid,type:type} });
    },
    getFranchisee(val) {
      let self = this;
      if (!this.searchData.tenantGuid) {
        // this.$message.error('请先选择所属企业');
        return
      }
      // this.franchiseeSelectLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo)
      let obj = {
        pageIndex: 1,
        pageSize: 30,
        tenantGuid: this.searchData.tenantGuid,
        franchiseeName: val,
      }
      this.api.postCan(
        `/${serverConfig.msCustomerService}/franchisee/data/get`, obj
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // this.franchiseeSelectLoading = false;
          this.franchiseeSelectList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getCustomer(val) {
      let self = this;
      if (!this.searchData.tenantGuid) {
        // this.$message.error('请先选择所属企业');
        return
      }
      // this.franchiseeSelectLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo)
      let obj = {
        pageIndex: 1,
        pageSize: 30,
        tenantGuid: this.searchData.tenantGuid,
        customerName: val,
      }
      this.api.postCan(
        `/${serverConfig.msCustomerService}/customer/data/get`, obj
      ).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          // this.franchiseeSelectLoading = false;
          this.customerList = res.data.data.records || [];
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    selectFocus() {
      if (!this.searchData.tenantGuid) {
        this.$message.error('请先选择所属企业');
      }
    },
    //获取公司
    getCompany() {
      let self = this;
      let query = {
        isService: true,
        tenantGuid: localStorage.guid,
      };
      self.api
        .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.companyList = res.data.data || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    companyChange(val) {
      if (!val) {
        this.searchData.franchiseeName = '';
      } else {
        this.getFranchisee()
        this.getCustomer()
      }
    },
    typeChange(val) {
      console.log('33',val);
      
      this.searchData.franchiseeName = '';
      if (val==10) {
        this.getFranchisee()
      } else {
        this.getCustomer()
      }
    },
    getList() {
      let self = this;
      // this.searchData.updateStartTime = this.updateTime[0]
      //   ? this.$moment(this.updateTime[0]).format('YYYY-MM-DD 00:00:00')
      //   : '';
      // this.searchData.updateEndTime = this.updateTime[1]
      //   ? this.$moment(this.updateTime[1]).format('YYYY-MM-DD 23:59:59')
      //   : '';
      // this.searchData.approveStartTime = this.approveTime[0]
      //   ? this.$moment(this.approveTime[0]).format('YYYY-MM-DD 00:00:00')
      //   : '';
      // this.searchData.approveEndTime = this.approveTime[1]
      //   ? this.$moment(this.approveTime[1]).format('YYYY-MM-DD 23:59:59')
      //   : '';
      if(!this.searchData.bizStateList.length){
        this.searchData.bizStateList=['Y','S']
      }
      if(self.multipleSelection && self.multipleSelection.length > 0){
        self.$refs.multipleTable.clearSelection();
      }
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/data/pc-list`, this.searchData).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records || [];
          self.clientType=this.searchData.clientType
          self.searchData.totalPage = res.data.data.totalPages;
          self.searchData.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      this.searchData = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        tenantGuid: '',
        clientName: '',
        clientType: '10',//客户类型 1=>10商业公司 2=>11居间人 15药店联系人
        franchiseeName: '',
        createUserName: '',
        createUserMobile: '',
        sendTenantGuid: localStorage.guid,
        // updateStartTime: '',//更新时间
        // updateEndTime: '',
        // updateName:'',//更新人
        // approveStartTime: '',// 审核时间
        // approveEndTime: '',
        // approveState:'',//审核状态
        bizStateList:['Y','S'],//启用状态
      };
      this.getList();
    },
    addContent(row,disabled) {
      if (!localStorage.getItem('TXL_CONFIG')) {
        this.$message.error('功能界面内容未配置，请联系运营人员处理')
        return
      }
      sessionStorage.removeItem('businessBack')
      if (row) {
        // sessionStorage.setItem('businessPageIndex',this.searchData.pageIndex)
        this.$router.push({
          path: '/businessCustomerAdd',
          query: {
            guid: row.guid,
            clientType:row.clientType,
            productGuid:this.$route.query.productGuid,
            disabled
          }
        })
      } else {
        // sessionStorage.removeItem('businessPageIndex')
        this.$router.push('/businessCustomerAdd?productGuid='+this.$route.query.productGuid+'&clientType='+this.searchData.clientType)
      }
    },
    // 去审核
    toReview(item) {
      this.$router.push({
        path: `/businessCustomerAudit`,
        query: {
          guid: item.guid,
          tenantGuid: this.searchData.tenantGuid,
          productGuid: this.$route.query.productGuid,

        },
      });
    },
    // report() {
    //   let self = this;
    //   let req = JSON.parse(JSON.stringify(this.searchData));
    //   req.pageSize = -1;
    //   self.fullscreenLoading = true;
    //   self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/export`, req).then(res => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       window.open(res.data.data)
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    report() {
      let self = this;
      let req = JSON.parse(JSON.stringify(this.searchData));
      req.pageSize = -1;
      self.api.postJsonD(`/${serverConfig.msPersonnelService}/address-list/export`, req)
        .then(res => {
          let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
          let fileName = '商业客户资料';
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a')
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
    },
    handleSizeChange(val) {
      let self = this;
      self.searchData.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.searchData.pageIndex = val;
      this.getList();
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.tableLoading = true;
          self.api.postJson(`/${serverConfig.msPersonnelService}/address-list/data/pc-delete`, self.multipleSelection).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.multipleSelection = [];
              self.tableLoading = false;
              self.$message.success('删除成功');
              self.getList(1);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    //批量停用、启用
    batchChangeState(flg) {
      // flg为停用(s)启用(Y)状态
      let str=''
      let tips=''
      let self = this;
      if (!this.multipleSelection.length) {
        this.$message.error("请勾选数据！");
        return;
      }
      if(flg==='S'){
        str='停用后，客户信息将不被服务人员看到，确定操作吗？'
        tips='批量停用成功'
      }else{
        str='启用后，负责该客户的服务人员将可以看到此信息，确定操作吗？'
        tips='批量启用成功'
      }
      
      this.$confirm(str, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        self.api
            .put(
              `/${serverConfig.msPersonnelService}/address-list/update-biz-state?bizState=${flg}`,
              self.multipleSelection
            )
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success(tips);
                self.$refs.multipleTable.clearSelection();
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
      })
    },
  },
};
</script> 
<style scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

.doctorInformation /deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

.doctorInformation /deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

.doctorInformation /deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

.doctorInformation /deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.doctorInformation /deep/ .el-form-item__label {
  text-align: right;
}

.doctorInformation /deep/ .el-select {
  width: 100%;
}

/* .doctorInformation .search-area {
  padding-bottom: 0;
  margin-bottom: 10px;
} */

.doctorInformation /deep/ .el-col-8 {
  height: 62px;
}
.search-area-div{
  flex-shrink: 0;
  margin-right: 4px;
  width:72px;
  text-align:right
}
.ipt-sty{
  flex: 1;
}
.el-col-6{
  display: flex;
  justify-content: flex-end;
}
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}

</style>
